import React from 'react';
import { Box, Card, CardHeader, CardContent, Paper, Table, TableBody, TableCell, TableContainer, TableRow, } from '@mui/material';
import { defineMessages, useIntl } from 'react-intl';
import StatusChip from './StatusChip';
import SpeedChart from './SpeedChart';
const msgs = defineMessages({
    headerTitle: {
        id: 'pages.member.vehicle.StatusCard.header.title',
        defaultMessage: 'Status',
    },
    headerSubTitle: {
        id: 'pages.member.vehicle.StatusCard.header.subTitle',
        defaultMessage: 'Vehicle status',
    },
});
function filterLastMetric(extractField, metrics) {
    const filtered = metrics?.filter(extractField);
    return filtered && filtered.length > 0 ? filtered[filtered.length - 1] : undefined;
}
function StatusCard({ realtimeMetrics, lastMetrics, refreshInterval }) {
    const intl = useIntl();
    const groundSpeed = (filterLastMetric((e) => !!e.groundSpeed, realtimeMetrics) || lastMetrics)
        ?.groundSpeed;
    const airSpeed = (filterLastMetric((e) => !!e.airSpeed, realtimeMetrics) || lastMetrics)?.airSpeed;
    const vehicleMode = (filterLastMetric((e) => !!e.vehicleMode, realtimeMetrics) || lastMetrics)
        ?.vehicleMode;
    const systemStatus = (filterLastMetric((e) => !!e.systemStatus, realtimeMetrics) || lastMetrics)
        ?.systemStatus;
    const armed = (filterLastMetric((e) => !!e.armed, realtimeMetrics) || lastMetrics)?.armed;
    const ekfOk = (filterLastMetric((e) => !!e.ekfOk, realtimeMetrics) || lastMetrics)?.ekfOk;
    const isArmable = (filterLastMetric((e) => !!e.isArmable, realtimeMetrics) || lastMetrics)?.isArmable;
    return (React.createElement(Card, null,
        React.createElement(CardHeader, { title: intl.formatMessage(msgs.headerTitle), subheader: intl.formatMessage(msgs.headerSubTitle), action: React.createElement(StatusChip, { realtimeMetrics: realtimeMetrics, lastMetrics: lastMetrics, hasField: (e) => {
                    const metrics = e;
                    return !!metrics.groundSpeed || !!metrics.airSpeed || !!metrics.vehicleMode || !!metrics.systemStatus;
                } }) }),
        React.createElement(CardContent, null,
            realtimeMetrics ? (React.createElement(Box, { sx: { height: 120 } },
                React.createElement(SpeedChart, { data: realtimeMetrics, refreshInterval: refreshInterval }))) : null,
            React.createElement(TableContainer, { component: Paper, elevation: 0 },
                React.createElement(Table, null,
                    React.createElement(TableBody, null,
                        React.createElement(TableRow, null,
                            React.createElement(TableCell, { align: "right" }, "Ground speed"),
                            React.createElement(TableCell, { align: "right" }, groundSpeed ? `${groundSpeed.toFixed(2)} m/s` : '-')),
                        React.createElement(TableRow, null,
                            React.createElement(TableCell, { align: "right" }, "Air speed"),
                            React.createElement(TableCell, { align: "right" }, airSpeed ? `${airSpeed.toFixed(2)} m/s` : '-')),
                        React.createElement(TableRow, null,
                            React.createElement(TableCell, { align: "right" }, "Vehicle mode"),
                            React.createElement(TableCell, { align: "right" }, vehicleMode ?? '-')),
                        React.createElement(TableRow, null,
                            React.createElement(TableCell, { align: "right" }, "System status"),
                            React.createElement(TableCell, { align: "right" }, systemStatus ?? '-')),
                        React.createElement(TableRow, null,
                            React.createElement(TableCell, { align: "right" }, "Armed"),
                            React.createElement(TableCell, { align: "right" }, armed ? 'Yes' : 'No')),
                        React.createElement(TableRow, null,
                            React.createElement(TableCell, { align: "right" }, "Ekf status"),
                            React.createElement(TableCell, { align: "right" }, ekfOk ? 'Yes' : 'No')),
                        React.createElement(TableRow, null,
                            React.createElement(TableCell, { align: "right" }, "Is armable"),
                            React.createElement(TableCell, { align: "right" }, isArmable ? 'Yes' : 'No'))))))));
}
export default React.memo(StatusCard);
